import type { estypes } from '@elastic/elasticsearch';

import { type SearchDomainAggregations } from '~/apps/product-plus/search-domain/types';

type SearchDomainResponse<TSource> = estypes.SearchResponseBody<TSource, SearchDomainAggregations>;

export function toTotalHits(
  total: estypes.SearchHitsMetadata<unknown>['total'],
  value: number,
  relationOverride?: estypes.SearchTotalHitsRelation,
): estypes.SearchTotalHits {
  if (relationOverride) {
    return { relation: relationOverride, value };
  }

  if (!total) {
    return { relation: 'eq', value };
  }

  if (typeof total === 'number') {
    return { relation: 'eq', value };
  }

  return { relation: total.relation ?? 'eq', value };
}

export function replaceResponseHits<TInSource, TOutSource>(
  searchResponse: SearchDomainResponse<TInSource>,
  params: {
    aggregations?: SearchDomainAggregations;
    hits: Array<estypes.SearchHit<TOutSource>>;
    isWalled?: boolean;
    totalRelation?: estypes.SearchTotalHitsRelation;
    totalValue: number;
  },
): SearchDomainResponse<TOutSource> {
  const nextHits = params.isWalled ? params.hits.slice(0, 1) : params.hits;

  return {
    ...searchResponse,
    aggregations: params.aggregations ?? searchResponse.aggregations,
    hits: {
      ...searchResponse.hits,
      total: toTotalHits(searchResponse.hits.total, params.totalValue, params.totalRelation),
      hits: nextHits,
    },
  } as SearchDomainResponse<TOutSource>;
}
